import { mergeProps } from '@zag-js/solid';
import { createSplitProps } from '../../utils/create-split-props';
import { ark } from '../factory';
import { usePagination } from './use-pagination';
import { PaginationProvider } from './use-pagination-context';
export const PaginationRoot = (props) => {
    const [usePaginationProps, localProps] = createSplitProps()(props, [
        'count',
        'defaultPage',
        'id',
        'ids',
        'onPageChange',
        'onPageSizeChange',
        'page',
        'pageSize',
        'siblingCount',
        'translations',
        'type',
    ]);
    const api = usePagination(usePaginationProps);
    const mergedProps = mergeProps(() => api().getRootProps(), localProps);
    return (<PaginationProvider value={api}>
      <ark.nav {...mergedProps}/>
    </PaginationProvider>);
};
